import React = require("react");
import { IPagination } from "../../store";

export interface IPaginationProps {
   pagination: IPagination
   search: (next: boolean) => void;
}

export const Pagination = (props: IPaginationProps): React.ReactElement<IPaginationProps> => {
    const previous = props.pagination.hasPreviousPage ? <button className={`wpo ui input button ${props.pagination.hasNextPage ? "is-first" : "is-last"} p-paging-previous`} onClick={(event: React.MouseEvent<HTMLElement>) => props.search(false)}>Previous</button> : null;
    const next = props.pagination.hasNextPage ? <button className="wpo ui input button is-last p-paging-next" onClick={(event: React.MouseEvent<HTMLElement>) => props.search(true)}>Next</button> : null;    

    return (
            <div className="wpo ui borderless panel p-paging-menu">
                {previous}
                {next}
			</div>
    )
};